module.exports = __webpack_public_path__ + "img/sway-loading.c65b0b0d.png";